<template>
  <td
    v-if="header.value === 'name'"
    v-once
    :class="`is-type--${data.type}`"
    class="LKReportsRoadmapDirectionEventStatisticsTableCell__name"
    v-html="value"
  />

  <td
    v-else-if="value === null || header.value === 'count'"
    v-once
    :style="header.style"
    :class="header.class"
    class="LKReportsRoadmapDirectionEventStatisticsTableCell__number"
    v-text="value"
  />

  <td
    v-else
    :style="header.style"
    :class="header.class"
    class="LKReportsRoadmapDirectionEventStatisticsTableCell__number"
  >
    <v-menu
      v-model="isActiveMenu"
      open-on-click
      offset-y
      :max-width="450"
      :max-height="500"
      :close-on-content-click="false"
    >
      <template #activator="{ on }">
        <div
          :class="{ 'is-active': isActiveMenu }"
          class="LKReportsRoadmapDirectionEventStatisticsTableCell__number-inner"
          v-on="on"
          v-text="value"
        />
      </template>

      <keep-alive>
        <MenuLinks
          v-if="isActiveMenu"
          :data="data"
          :roadmap-id="roadmapId"
          :type="header.value"
        />
      </keep-alive>
    </v-menu>
  </td>
</template>

<script>
import MenuLinks from './LKReportsRoadmapDirectionEventStatisticsMenuLinks.vue'


export default {
  name: 'LKReportsRoadmapDirectionEventStatisticsTableCell',
  components: {
    MenuLinks,
  },
  props: {
    header: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    roadmapId: {
      type: [Number, String],
      required: true,
    },
    value: [String, Number],
  },
  data: () => ({
    isActiveMenu: false,
  }),
}
</script>

<style lang="scss">
.LKReportsRoadmapDirectionEventStatisticsTableCell {
  &__name {
    &.is-type {
      &--roadmap_direction {
        padding-left: 0;
      }

      &--base_event {
        padding-left: 40px !important;
      }
    }
  }

  &__number {
    position: relative;
    font-weight: 700;
    text-align: center;
    word-break: keep-all !important;

    &-inner {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &.is-active {
        background-color: rgba($color-gray, 03);
      }
    }
  }
}
</style>
